export class ApiPermissionRequest {
    serviceId: number;
    permId: number;
    permName: string;
    permType: string;
    permCode: string;
    permDesc: string;
}